import { Route, Switch } from "react-router-dom";
import TransferenciasListagem from "./Listagem";

function TransferenciasPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/transferencias"
        component={TransferenciasListagem}
      />
    </Switch>
  );
}

export default TransferenciasPages;
